import '../sass/includes.scss';
import Router from '@/core/router';
import ModuleMobilenav from '@/modules/mobilenav';
import ModuleBacktotop from '@/modules/backtotop';
import ModuleCustomselect from '@/modules/customselect';
import ModuleGallery from '@/modules/gallery';
import ModuleContentHide from '@/modules/contenthide';
import ModuleAjaxForm from '@/modules/ajaxform';
import ModuleAddToCart from '@/modules/addtocart';
import ModuleOfferte from '@/modules/offerte';
import ModuleCart from '@/modules/cart';
import ModuleOfferteForm from '@/modules/offerteForm';
import $ from 'jquery';

import _ from 'lodash';

console.log($);

window.$ = $;
window.jQuery = $;

Router.setup({
    options: {
        ajaxloading: false
    },
    modules: [
        {
            class: ModuleBacktotop,
            element: 'body'
        },
        {
            class: ModuleMobilenav,
            element: '.mobile-menu'
        },
        {
            class: ModuleAjaxForm,
            element: '[ajax-form]'
        },
        {
            class: ModuleCustomselect,
            element: 'select'
        },

        {
            class: ModuleGallery,
            element: '.product-slider'
        },

        {
            class: ModuleContentHide,
            element: '.content--notall'
        },
        {
            class: ModuleAddToCart,
            element: document
        },
        {
            class: ModuleOfferte,
            element: '[offerte]'
        },
        {
            class: ModuleOfferteForm,
            element: '[name="offerte"]'
        },
        {
            class: ModuleCart,
            element: '.cart'
        },
        {
            load: () => import('@/modules/labelcreator2'),
            element: '#labelcreator2'
        }
    ]
});

$('.woocommerce-terms-and-conditions-link').on('click', (e) => {
    e.preventDefault();

    $('.terms-conditions').show();
});